const mutations = {
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_TOKENS(state, { accessToken, refreshToken }) {
    state.tokens.access = accessToken ?? null;
    state.tokens.refresh = refreshToken ?? null;
    state.isAuthenticated = Boolean(accessToken);
  },
  SET_USER(state, user) {
    state.user = user ?? null;
  },
  SET_ROLE(state, role) {
    state.role = role ?? null;
  },
  SET_SESSION_RESTORED(state, restored) {
    state.sessionRestored = restored;
  },
  CLEAR_AUTH_STATE(state) {
    state.user = null;
    state.role = null;
    state.tokens.access = null;
    state.tokens.refresh = null;
    state.isAuthenticated = false;
  },
};

export default mutations;
